var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"o-main py-5"},[_c('div',{staticClass:"container"},[_c('nuxt')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }